import React from "react"

const CloseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M9.08366 0.916626L0.916992 9.08329" stroke="#606060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M0.916992 0.916626L9.08366 9.08329" stroke="#606060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default CloseIcon